import React from 'react';
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;

export default ({ onAccept }) => (
    <div className="videoScreen-container" style={{ padding: '30px' }}>
        <br />
        <div className="row" style={{ height: '50px' }}>
            <div className="col-md-1 col-xs-1">
                <span className="icons icons--icon-warning" style={{ height: '40px', width: '40px' }} />
            </div>
            <div className="col-md-10 col-xs-10" style={{ height: '50px' }}>
                <h3 className="font-heading3" style={{ lineHeight: '50px', paddingLeft: '20px' }}>
                    {formatText('identity-videoCallErrorTitle')}
                </h3>
            </div>
        </div>
        <hr />
        <div className="row">
            <FormattedText value="identity-videoCallAllowCameraDesktop" />
        </div>
        <hr />
        <div className="video-screen__modal-buttons">
            <button className="form__button form__button-secondary error_button" onClick={onAccept}>
                {formatText('button-understood')}
            </button>
        </div>
    </div>
);
